import React from "react";
import "../css/Home6.css";

const Home6 = () => {
  return (
    <div className="home6">

      {/* ======================================================
          HERO — EDITORIAL SPLIT
      ======================================================= */}
      <section className="h6-hero">
        <div className="h6-hero-left">
          <h1>
            Built<br />For<br />Discipline
          </h1>
          <p>
            GRIT is an urban performance lab where consistency,
            structure, and strength define every session.
          </p>
        </div>

        <div className="h6-hero-right">
          <img
            src="https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg"
            alt="training"
          />
        </div>
      </section>


      {/* ======================================================
          SECTION — MANIFESTO STRIP
      ======================================================= */}
      <section className="h6-manifesto">
        <div className="man-line"></div>
        <p>
          NO HYPE. NO SHORTCUTS. JUST WORK.
        </p>
        <div className="man-line"></div>
      </section>


      {/* ======================================================
          SECTION — GRID STATEMENT
      ======================================================= */}
      <section className="h6-grid-statement">
        <div className="gs-item big">
          <h2>Strength<br />Is Structured</h2>
        </div>

        <div className="gs-item">
          <h3>Precision Training</h3>
          <p>Programs built on mechanics, control, and progression.</p>
        </div>

        <div className="gs-item">
          <h3>Urban Discipline</h3>
          <p>Training for real life, real bodies, real schedules.</p>
        </div>

        <div className="gs-item img">
          <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" />
        </div>
      </section>


      {/* ======================================================
          SECTION — FULL WIDTH IMPACT
      ======================================================= */}
      <section className="h6-impact">
        <h2>Train With Intention</h2>
        <p>
          Every session is engineered to build strength that lasts,
          not motivation that fades.
        </p>
      </section>


      {/* ======================================================
          SECTION — PROGRAM BLOCKS
      ======================================================= */}
      <section className="h6-programs">

        <div className="prog-card">
          <h3>Strength Systems</h3>
          <p>Barbell, kettlebell, and controlled compound training.</p>
        </div>

        <div className="prog-card">
          <h3>Conditioning Cycles</h3>
          <p>Structured metabolic work without chaos.</p>
        </div>

        <div className="prog-card">
          <h3>Mobility Control</h3>
          <p>Restore range, posture, and joint resilience.</p>
        </div>

      </section>


      {/* ======================================================
          SECTION — IMAGE / TEXT SPLIT
      ======================================================= */}
      <section className="h6-split">

        <div className="split-img">
          <img src="https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" />
        </div>

        <div className="split-text">
          <h2>Designed Like A System</h2>
          <p>
            We don’t chase trends. We design systems.
            Training that evolves with your body, not against it.
          </p>
        </div>

      </section>


      {/* ======================================================
          SECTION — BOLD TYPO PANEL
      ======================================================= */}
      <section className="h6-typography">
        <h1>CONSISTENCY<br />OVER<br />INTENSITY</h1>
      </section>


      {/* ======================================================
          SECTION — LOCATION PANEL
      ======================================================= */}
      <section className="h6-location">
        <div className="loc-text">
          <h2>Urban Training Lab</h2>
          <p>
            Industrial space. Minimal noise. Maximum focus.
            Built for people who show up.
          </p>
        </div>

        <div className="loc-img">
          <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" />
        </div>
      </section>

    </div>
  );
};

export default Home6;
